import {
  createTenantContact as create,
  deleteTenantContact as remove,
  getTenantContacts as retrieve,
  saveTenantContact as save,
} from "api/tenant_contact";

import { splitName } from "utils/user";

export const TENANT_CONTACTS_GET = "TENANT_CONTACTS_GET";

export const getTenantContacts = (dealID) => (dispatch) =>
  dispatch({
    type: TENANT_CONTACTS_GET,
    payload: retrieve(dealID),
  });

export const TENANT_CONTACT_SAVE = "TENANT_CONTACT_SAVE";
export const TENANT_CONTACT_CREATE = "TENANT_CONTACT_CREATE";

export const saveTenantContact = (dealID, tenantContact) => (dispatch) => {
  const contact = { ...tenantContact, ...splitName(tenantContact.name) };

  if (tenantContact.id) {
    return dispatch({
      type: TENANT_CONTACT_SAVE,
      payload: save(dealID, contact),
    });
  }

  return dispatch({
    type: TENANT_CONTACT_CREATE,
    payload: create(dealID, contact),
  });
};

export const TENANT_CONTACT_DELETE = "TENANT_CONTACT_DELETE";

export const deleteTenantContact = (dealID, tenantContactID) => (dispatch) =>
  dispatch({
    type: TENANT_CONTACT_DELETE,
    payload: remove(dealID, tenantContactID),
    meta: { tenantContactID },
  });
